
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.79.82v.383c-.319.089-.543.17-.673.242a.95.95 0 00-.32.29c-.078.114-.136.283-.172.507a8.822 8.822 0 00-.047 1.086v9.524c0 .468.016.815.047 1.039.031.229.083.403.156.523a.855.855 0 00.305.305c.135.083.37.169.703.258v.382H7.65v-.382c.312-.084.533-.165.663-.243a.878.878 0 00.313-.289c.078-.12.133-.294.164-.523.037-.224.055-.58.055-1.07V1.648H3.14v11.204c0 .505.015.867.046 1.085.037.22.094.386.172.5.079.12.185.22.32.297.136.079.363.16.68.243v.382H.211v-.382c.312-.084.536-.165.672-.243a.781.781 0 00.312-.296c.078-.12.133-.292.164-.516.037-.224.055-.58.055-1.07V3.328c0-.49-.018-.846-.055-1.07-.03-.224-.083-.393-.156-.508a.858.858 0 00-.312-.297c-.13-.078-.357-.161-.68-.25V.82h11.578z","fill":"currentColor"}})])
          )
        }
      }
    